import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { addToBreadCrumpData, checkPermission, popBreadCrumpData } from "../../../config/utils";
import { Dropdown } from "react-bootstrap";
import ReactTooltip from "react-tooltip";
import Portal from "./Portal";
import { connect } from "react-redux";
import ConfirmationModal from "./ConfirmationModal";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../../assets/css/info-tab.css";
import { RECOMMENDATION_SOURCE_TYPES } from "../constants";
import { setPendingAction, triggerUnsavedChangesPrompt } from "../actions";
import StarIcon from "../../../assets/img/star.svg";
import StarActiveIcon from "../../../assets/img/star-active.svg";
import { addToQuickLinks, deleteQuickLinks, getQuickLinks } from "../../dashboard/actions";
import "./infoTabs.css";
import { WithTooltip } from "../../../utils/glossaryHelper/GlossaryWithTooltip";
import { rebuildGlossaryTooltip } from "../../../utils/glossaryHelper/GlossaryTooltip";
import { navigateWithPrompts } from "../../../utils/navigationHelpers";
import qs from "query-string";
import { sanitizeHtml } from "./SafeHtml";
import { permissions } from "../../../config/permissions";
import {
    DEFAULT_CAPITAL_REQUEST_LABEL,
    getCapitalRequestLabel,
    getQuickLinkStoredName
} from "../../../utils/capitalRequestLabel";
import { CLIENT_DYNAMIC_TABLES_TAB } from "../../dynamicTables/constants";
class InfoTabs extends Component {
    constructor(props) {
        super(props);
        this.sliderRef = React.createRef();
        this.addNewLabelRef = React.createRef();
        this._lastAutoScrolledTabIndex = null;
        this._autoScrollRetryCount = 0;
        this._infoTabsSignature = null;
        this._lastWheelAt = 0;
        this.state = {
            startIndex: 0,
            SlickBtnShow: false,
            quickLinksConfirmationModal: { show: false, item: null },
            addDropdownLabelTruncated: false,
            slidesToShow: 1,
            slidesToScroll: 1
        };
    }
    handleTabClick = async item => {
        const capitalRequestLabel = getCapitalRequestLabel(this.props.projectReducer?.getProjectByIdResponse?.miscellaneous);
        const {
            history,
            match: {
                params: { section }
            },
            location: { search },
            isSurveyStandards = "",
            isSurveyUniformat = "",
            isGlobalProjectSettingsTab = false,
            isTemplateSettingsTwoTabMode = false
        } = this.props;
        const query = qs.parse(search);
        switch (item.key) {
            case "basicdetails":
                addToBreadCrumpData({
                    key: "info",
                    name: "Basic Details",
                    path: item.path,
                    disabled: item?.disabled ?? false
                });
                break;
            case "additionaldetails":
                addToBreadCrumpData({
                    key: "info",
                    name: "Additional Details",
                    path: item.path
                });
                break;
            case "assetdetails":
                addToBreadCrumpData({
                    key: "info",
                    name: "Asset Details",
                    path: item.path
                });
                break;
            case "maindetails":
                addToBreadCrumpData({
                    key: "info",
                    name: "Main Details",
                    path: item.path,
                    isInnerTab: query?.is_assignedRecom === "true" ? true : false
                });
                break;
            case "weightedScore":
                addToBreadCrumpData({
                    key: "info",
                    name: "Assessment Table",
                    path: item.path
                });
                break;
            case "checklists":
                addToBreadCrumpData({
                    key: "info",
                    name: "Checklists",
                    path: item.path,
                    isInnerTab: query?.is_assignedRecom === "true" ? true : false
                });
                break;
            case "infoimages":
                if (isSurveyStandards || isSurveyUniformat)
                    addToBreadCrumpData({
                        key: "basicdetails",
                        name: "Images",
                        path: item.path
                    });
                else
                    addToBreadCrumpData({
                        key: "info",
                        name: "Images",
                        path: item.path,
                        isInnerTab: query?.is_assignedRecom === "true" ? true : false
                    });
                break;
            case "infomap":
                addToBreadCrumpData({
                    key: "info",
                    name: "Map",
                    path: item.path
                });
                break;
            case "sites":
                addToBreadCrumpData({
                    key: "info",
                    name: "Sites",
                    path: item.path
                });
                break;
            case "buildingLease":
                addToBreadCrumpData({
                    key: "info",
                    name: "Leases",
                    path: item.path
                });
                break;
            case "lease-income":
                addToBreadCrumpData({
                    key: "info",
                    name: "Income",
                    path: item.path
                });
                break;
            case "lease-expense":
                addToBreadCrumpData({
                    key: "info",
                    name: "Expense",
                    path: item.path
                });
                break;
            case "regions":
                addToBreadCrumpData({
                    key: "info",
                    name: "Regions",
                    path: item.path
                });
                break;
            case "recommendations":
                addToBreadCrumpData({
                    key: "info",
                    name: "Recommendations",
                    path: item.path,
                    isInnerTab: query?.is_assignedRecom === "true" ? true : false,
                    isNestedTab: query?.is_assignedRecom === "true"
                });
                break;

            case "buildings":
                addToBreadCrumpData({
                    key: "info",
                    name: "Buildings",
                    path: item.path
                });
                break;
            case "floors":
                addToBreadCrumpData({
                    key: "info",
                    name: "Floors",
                    path: item.path
                });
                break;
            case "buildingAddition":
                addToBreadCrumpData({
                    key: "info",
                    name: "Additions",
                    path: item.path
                });
                break;
            case "settings":
                addToBreadCrumpData({
                    key: "info",
                    name: item.bcName || "Settings",
                    path: item.path
                });
                break;
            // case "reports":
            //     addToBreadCrumpData({
            //         key: "info",
            //         name: item.bcName || "Reports",
            //         path: item.path
            //     });
            //     break;
            case "futurecapital":
                addToBreadCrumpData({
                    key: "info",
                    name: "Future Capital",
                    path: item.path
                });
                break;
            case "deferredmaintenance":
                addToBreadCrumpData({
                    key: "info",
                    name: "Deferred Maintenance",
                    path: item.path
                });
                break;
            case "efci":
                addToBreadCrumpData({
                    key: "info",
                    name: "EFCI",
                    path: item.path
                });
                break;
            case "softCosts":
                addToBreadCrumpData({
                    key: "info",
                    name: "Project Costs",
                    path: item.path,
                    isInnerTab: query?.is_assignedRecom === "true" ? true : false
                });
                break;
            case "building_color_chart":
                addToBreadCrumpData({
                    key: "info",
                    name: "Stoplight Chart",
                    path: item.path
                });
                break;
            case "efcisandbox":
                addToBreadCrumpData({
                    key: "info",
                    name: "EFCI Sandbox",
                    path: item.path
                });
                break;

            case "dashboard":
                addToBreadCrumpData({
                    key: "info",
                    name: "Charts & Graphs",
                    path: item.path
                });
                break;

            case "clients":
                addToBreadCrumpData({
                    key: "info",
                    name: "Clients",
                    path: item.path
                });
                break;
            case "settingsbasicdata":
                addToBreadCrumpData({
                    key: "info",
                    name: "Settings Info",
                    path: item.path
                });
                break;
            case "history":
                addToBreadCrumpData({
                    key: "info",
                    name: "Import History",
                    path: item.path
                });
                break;
            case "export-history":
                addToBreadCrumpData({
                    key: "info",
                    name: "Export History",
                    path: item.path
                });
                break;
            case "escalation":
                addToBreadCrumpData({
                    key: "info",
                    name: "Project Costs",
                    path: item.path
                });
                break;
            case "exporthistory":
                addToBreadCrumpData({
                    key: "info",
                    name: "Export History",
                    path: item.path
                });
                break;
            case "projects":
                addToBreadCrumpData({
                    key: "info",
                    name: "FCA Projects",
                    path: item.path
                });
                break;
            case "color_code":
                addToBreadCrumpData({
                    key: "info",
                    name: "FCI Color Codes",
                    path: item.path
                });
                break;
            case "initiatives":
                popBreadCrumpData();
                break;
            case "recommendation":
                addToBreadCrumpData({
                    key: "info",
                    name: "Recommendations",
                    path: item.path
                });
                break;
            case "assignednarrativetemplate":
                addToBreadCrumpData({
                    key: "info",
                    name: "Assigned Narrative Template",
                    path: item.path
                });
                break;
            case "assignedtabletemplate":
                addToBreadCrumpData({
                    key: "info",
                    name: "Assigned Table Template",
                    path: item.path
                });
                break;
            case "assignedreportnotetemplate":
                addToBreadCrumpData({
                    key: "info",
                    name: "Assigned Recommendation Narrative Template",
                    path: item.path
                });
                break;
            case "assignedrecommendationtemplate":
                addToBreadCrumpData({
                    key: "info",
                    name: "Assigned Recommendation Template",
                    path: item.path
                });
                break;
            case "fontnames":
                addToBreadCrumpData({
                    key: "info",
                    name: "Font Names",
                    path: item.path
                });
                break;
            case "tablestyles":
                addToBreadCrumpData({
                    key: "info",
                    name: "Table Styles",
                    path: item.path
                });
                break;
            case "Electricity":
                addToBreadCrumpData({
                    key: "info",
                    name: "Electricity",
                    path: item.path
                });
                break;
            case "Gas":
                addToBreadCrumpData({
                    key: "info",
                    name: "Gas",
                    path: item.path
                });
                break;
            case "Water":
                addToBreadCrumpData({
                    key: "info",
                    name: "Water",
                    path: item.path
                });
                break;
            case "Sewer":
                addToBreadCrumpData({
                    key: "info",
                    name: "Sewer",
                    path: item.path
                });
                break;
            case "energyStarRating":
                addToBreadCrumpData({
                    key: "info",
                    name: "Energy Star Rating",
                    path: item.path
                });
                break;
            case "energydashboard":
                addToBreadCrumpData({
                    key: "info",
                    name: "Energy Dashboard",
                    path: item.path
                });
                break;
            case "assets":
                addToBreadCrumpData({
                    key: "info",
                    name: "Assets",
                    path: item.path
                });
                break;
            case "survey-assets":
                addToBreadCrumpData({
                    key: "info",
                    name: "Mobile Assets",
                    path: item.path
                });
                break;
            case "documents":
                addToBreadCrumpData({
                    key: "info",
                    name: "Documents",
                    path: item.path,
                    isInnerTab: query?.is_assignedRecom === "true" ? true : false
                });
                break;
            case "files":
                addToBreadCrumpData({
                    key: "info",
                    name: "Files",
                    path: item.path
                });
                break;
            case "smartchartReports":
                addToBreadCrumpData({
                    key: "info",
                    name: "Reports",
                    path: item.path
                });
                break;
            case "chart_templates":
                addToBreadCrumpData({
                    key: "info",
                    name: "Chart Templates",
                    path: item.path
                });
                break;
            case "chartProperties":
                addToBreadCrumpData({
                    key: "info",
                    name: "Chart Properties",
                    path: item.path
                });
                break;

            case "passwordsettings":
                addToBreadCrumpData({
                    key: "info",
                    name: "Password Settings",
                    path: item.path
                });
                break;
            case "capitalrequest":
                addToBreadCrumpData({
                    key: "info",
                    name: DEFAULT_CAPITAL_REQUEST_LABEL,
                    path: item.path
                });
                break;
            case "cr-recommendations":
                addToBreadCrumpData({
                    key: "info",
                    name: capitalRequestLabel,
                    path: item.path,
                    isInnerTab: query?.is_assignedRecom === "true" ? true : false
                });
                break;
            case "mr-recommendations":
                addToBreadCrumpData({
                    key: "info",
                    name: "Recommendation",
                    path: item.path,
                    isCr: true,
                    isInnerTab: query?.is_assignedRecom === "true" ? true : false,
                    isNestedTab: query?.is_assignedRecom === "true"
                });
                break;
            case "mobile-recommendations":
                addToBreadCrumpData({
                    key: "info",
                    name: "Mobile Recommendations",
                    path: item.path,
                    isInnerTab: query?.is_assignedRecom === "true" ? true : false
                });
                break;
            case "mr-assets":
                addToBreadCrumpData({
                    key: "info",
                    name: "Assets",
                    path: item.path,
                    isInnerTab: query?.is_assignedRecom === "true" ? true : false,
                    isNestedTab: query?.is_assignedRecom === "true"
                });
                break;
            case "qaqc":
                addToBreadCrumpData({
                    key: "info",
                    name: "Qa/Qc",
                    path: item.path,
                    isInnerTab: query?.is_assignedRecom === "true" ? true : false
                });
                break;
            case "recommendationdynamicfield":
                addToBreadCrumpData({
                    key: "info",
                    name: "Recommendation Dynamic Fields",
                    path: item.path
                });
                break;
            case "assetdynamicfield":
                addToBreadCrumpData({
                    key: "info",
                    name: "Assets Dynamic Fields",
                    path: item.path
                });
                break;
            case "buildingdynamicfield":
                addToBreadCrumpData({
                    key: "info",
                    name: "Buildings Dynamic Fields",
                    path: item.path
                });
                break;
            case "bandsdynamicfield":
                addToBreadCrumpData({
                    key: "info",
                    name: "Dynamic Field Bands",
                    path: item.path
                });
                break;
            case "leasedynamicfield":
                addToBreadCrumpData({
                    key: "info",
                    name: "Lease Dynamic Fileds",
                    path: item.path
                });
                break;
            case "dynamictablefields":
                addToBreadCrumpData({
                    key: "info",
                    name: "Fields",
                    path: item.path
                });
                break;
            case "dynamictablerecords":
                addToBreadCrumpData({
                    key: "info",
                    name: "Records",
                    path: item.path
                });
                break;
            case "dynamictablebands":
                addToBreadCrumpData({
                    key: "info",
                    name: "Bands",
                    path: item.path
                });
                break;
            case CLIENT_DYNAMIC_TABLES_TAB:
                addToBreadCrumpData({
                    key: "info",
                    name: "Client Dynamic Tables",
                    path: item.path
                });
                break;
            case "shift-csp-history":
                addToBreadCrumpData({
                    key: "info",
                    name: "Shift History",
                    path: item.path
                });
                break;
            case "linked-recommendations":
                addToBreadCrumpData({
                    key: "info",
                    name: "Recommendations",
                    path: item.path,
                    isCr: true
                });
                break;
            case "linked-cr-recommendations":
                addToBreadCrumpData({
                    key: "info",
                    name: capitalRequestLabel,
                    path: item.path,
                    isInnerTab: query?.is_assignedRecom === "true" ? true : false,
                    isNestedTab: query?.is_assignedRecom === "true" ? true : false
                });
                break;
            case "voiceNotes":
                addToBreadCrumpData({
                    key: "info",
                    name: "Voice Notes",
                    path: item.path,
                    isInnerTab: query?.is_assignedRecom === "true"
                });
                break;
            case "videos":
                addToBreadCrumpData({
                    key: "info",
                    name: "Videos",
                    path: item.path,
                    isInnerTab: query?.is_assignedRecom === "true"
                });
                break;

            case "app-info":
                addToBreadCrumpData({
                    key: "info",
                    name: "ADC Surveyor App Info",
                    path: item.path
                });
                break;
            case "fca-app-info":
                addToBreadCrumpData({
                    key: "info",
                    name: "FCA Surveyor App Info",
                    path: item.path
                });
                break;

            case "app-project-info":
                addToBreadCrumpData({
                    key: "info",
                    name: "ADC Project Table",
                    path: item.path
                });
                break;
            case "fca-app-project-info":
                addToBreadCrumpData({
                    key: "info",
                    name: "FCA Project Table",
                    path: item.path
                });
                break;
            case "project-history-info":
                popBreadCrumpData();
                addToBreadCrumpData({
                    key: "project-history-info",
                    name: "History",
                    path: item.path
                });
                break;
            case "surveyor-project-history":
                popBreadCrumpData();
                addToBreadCrumpData({
                    key: "surveyor-project-history",
                    name: "History",
                    path: item.path
                });
                break;
            case "basic-detail":
                popBreadCrumpData();
                addToBreadCrumpData({
                    key: "info",
                    name: "Basic Details",
                    path: item.path
                });
                break;
            case "info":
                if (isSurveyStandards || isSurveyUniformat) {
                    addToBreadCrumpData({
                        key: "basicdetails",
                        name: "Basic Details",
                        path: item.path
                    });
                    break;
                }
            case "ai-analyse":
                addToBreadCrumpData({
                    key: "info",
                    name: "AI Analysis",
                    path: item.path,
                    isInnerTab: query?.is_assignedRecom === "true"
                });
                break;
            case "checklist":
                addToBreadCrumpData({
                    key: "info",
                    name: "Checklists",
                    path: item.path,
                    isInnerTab: query?.is_assignedRecom === "true"
                });
                break;
            default:
                if (isGlobalProjectSettingsTab || isTemplateSettingsTwoTabMode)
                    addToBreadCrumpData({
                        key: "info",
                        name: item.name,
                        path: item.path
                    });
                else
                    addToBreadCrumpData({
                        key: "info",
                        name: "Sites",
                        path: item.path
                    });
                break;
        }

        if (section === "efciinfo") {
            await this.props.setActiveTab(item);
        }
        if (!item.path) {
            this.props.handleInnerTabClick(item.key);
        } else {
            history.push(item.path, item.state);
        }
    };

    recommendationSurveyLockDropdown(basicDetails) {
        const hasLockPerm = checkPermission("forms", "recommendations", "lock");
        const regularLocked = basicDetails?.locked === true;
        const regularTitle = !hasLockPerm
            ? "You do not have permission to change the recommendation lock."
            : regularLocked
              ? "Click to Unlock this Recommendation"
              : "Click to Lock this Recommendation";
        return (
            <>
                <Dropdown className="recom-survey-lock-dropdown">
                    <Dropdown.Toggle id="dropdown-basic" className="locking-center recom-survey-lock-dropdown__toggle" variant="link" type="button">
                        <img src="/img/lock-whi.svg" alt="survey-lock" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <ReactTooltip className="rc-tooltip-custom-class" id="recom-lock-opt" place="left" effect="solid" backgroundColor="#007bff" />
                        <ReactTooltip
                            className="rc-tooltip-custom-class"
                            id="recom-survey-lock-opt"
                            place="left"
                            effect="solid"
                            backgroundColor="#007bff"
                        />
                        <Dropdown.Item
                            onClick={() => {
                                if (hasLockPerm && this?.props?.lockItem) {
                                    this.props.lockItem();
                                }
                            }}
                        >
                            <span className="recom-lock-menu-item__row" data-tip={regularTitle} data-for="recom-lock-opt">
                                <span className={`recom-lock-menu-item__icon-wrapper ${regularLocked ? "locked-bg" : "unlocked-bg"}`}>
                                    <img
                                        src={regularLocked ? "/img/lock-whi.svg" : "/img/unlock.svg"}
                                        alt="lock-status"
                                        className="recom-lock-menu-item__icon-img"
                                    />
                                </span>
                                <span>{regularLocked ? "Regular- Lock" : "Regular- Unlock"}</span>
                            </span>
                        </Dropdown.Item>

                        <Dropdown.Divider className="info-tabs-add-menu__qa-split recom-survey-lock-dropdown__divider" />

                        <Dropdown.Item className="cursor-disabled">
                            <span
                                className="recom-lock-menu-item__row"
                                data-tip="This recommendation is linked to an active survey and will unlock once the survey is completed."
                                data-for="recom-survey-lock-opt"
                            >
                                <span className="recom-lock-menu-item__icon-wrapper locked-bg">
                                    <img src="/img/lock-whi.svg" alt="survey-lock" className="recom-lock-menu-item__icon-img" />
                                </span>
                                <span>Survey- Lock</span>
                            </span>
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </>
        );
    }
    lockIcon(basicDetails) {
        const hasLock = checkPermission("forms", "recommendations", "lock");
        return (
            <>
                <ReactTooltip id="lock" place="bottom" effect="solid" backgroundColor="#007bff" />
                <div
                    data-tip={this.props.isRecommendation ? "Click to Unlock this Recommendation" : ""}
                    data-for="lock"
                    onClick={() => hasLock && this.props.lockItem && this.props.lockItem()}
                    className={`${basicDetails === true ? "locked" : "unlocked"} locking-center cursor-hand`}
                >
                    {this.props.lockloading1 || this.props.lockloading ? (
                        <span className="spinner-border spinner-border-sm pl-2" role="status"></span>
                    ) : (
                        <img src="/img/lock-whi.svg" alt="" className="export" />
                    )}
                </div>
            </>
        );
    }

    unlockIcon(basicDetails) {
        const hasLock = checkPermission("forms", "recommendations", "lock");
        return (
            <>
                <ReactTooltip id="unlock" place="bottom" effect="solid" backgroundColor="#007bff" />
                <div
                    data-tip={this.props.isRecommendation ? "Click to Lock this Recommendation" : ""}
                    data-for="unlock"
                    onClick={() => hasLock && this.props.lockItem && this.props.lockItem()}
                    className={`${basicDetails === true ? "locked" : "unlocked"} locking-center cursor-hand`}
                >
                    {this.props.lockloading1 || this.props.lockloading ? (
                        <span className="spinner-border spinner-border-sm pl-2" role="status"></span>
                    ) : (
                        <svg
                            version="1.1"
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            width="17.064px"
                            height="15.289px"
                            viewBox="0 0.147 17.064 15.289"
                            enableBackground="new 0 0.147 17.064 15.289"
                            xmlSpace="preserve"
                        >
                            <g>
                                <g>
                                    <path
                                        fill="none"
                                        d="M1.123,8.031v5.6c0.001,0.375,0.308,0.682,0.684,0.683h7.467c0.375-0.001,0.682-0.308,0.684-0.683v-5.6
C9.957,7.653,9.649,7.345,9.274,7.345H1.807C1.43,7.346,1.123,7.654,1.123,8.031z M5.54,8.09c0.994,0.001,1.805,0.811,1.807,1.804
c0,0.8-0.525,1.473-1.246,1.71v1.403C6.099,13.32,5.847,13.57,5.54,13.57H5.537c-0.309-0.001-0.56-0.254-0.558-0.563v-1.403
c-0.72-0.236-1.245-0.909-1.245-1.708C3.734,8.9,4.544,8.09,5.54,8.09z"
                                    />
                                    <circle fill="none" cx="5.54" cy="9.897" r="0.684" />
                                    <path
                                        fill="#707070"
                                        d="M0,8.029v5.602c0.001,0.995,0.811,1.805,1.806,1.806h7.468c0.994-0.001,1.805-0.811,1.806-1.806V8.028
c-0.001-0.797-0.524-1.469-1.245-1.705H1.241C0.523,6.563,0.001,7.232,0,8.029z M9.274,7.345c0.375,0,0.683,0.308,0.684,0.686v5.6
c-0.002,0.375-0.309,0.682-0.684,0.683H1.807c-0.376-0.001-0.683-0.308-0.684-0.683v-5.6c0-0.377,0.307-0.685,0.684-0.686H9.274z"
                                    />
                                    <path
                                        fill="#707070"
                                        d="M4.979,11.604v1.403c-0.002,0.309,0.249,0.562,0.558,0.563H5.54c0.307,0,0.559-0.25,0.561-0.563v-1.403
c0.721-0.237,1.246-0.91,1.246-1.71C7.345,8.901,6.534,8.091,5.54,8.09c-0.996,0-1.806,0.81-1.806,1.806
C3.734,10.695,4.259,11.367,4.979,11.604z M5.54,9.213c0.377,0,0.684,0.307,0.684,0.682c0,0.377-0.308,0.685-0.684,0.686
c-0.376-0.001-0.683-0.308-0.683-0.685C4.857,9.52,5.164,9.213,5.54,9.213z"
                                    />
                                </g>
                                <path
                                    fill="#707070"
                                    d="M9.596,4.442c0-1.749,1.424-3.173,3.173-3.173c1.75,0,3.173,1.423,3.173,3.173v1.881h1.123V4.442
c-0.003-2.365-1.93-4.292-4.295-4.295c-2.366,0.003-4.292,1.93-4.295,4.295v1.881h1.121V4.442z"
                                />
                            </g>
                        </svg>
                    )}
                </div>
            </>
        );
    }

    componentDidMount() {
        window.addEventListener("resize", this.handleResize);
        this.observeTableTopMenuWidth();
        rebuildGlossaryTooltip();
        this.autoScrollToActiveTab(true);
        this._scheduleAddDropdownLabelTruncation();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.infoTabsData?.length !== this.props.infoTabsData?.length && this.props?.isRecommendation) {
            this.handleResize();
        }
        // Route/tab param changes should keep the active tab visible in the slider.
        const prevPath = prevProps?.location?.pathname;
        const nextPath = this.props?.location?.pathname;
        const prevSearch = prevProps?.location?.search;
        const nextSearch = this.props?.location?.search;
        if (
            prevPath !== nextPath ||
            prevSearch !== nextSearch ||
            prevProps.infoTabsData !== this.props.infoTabsData ||
            prevProps.infoTabsData?.length !== this.props.infoTabsData?.length
        ) {
            this.autoScrollToActiveTab();
        }
        if (
            prevProps.entityName !== this.props.entityName ||
            prevProps.hasCreate !== this.props.hasCreate ||
            prevProps.canAddNewQaQcIssue !== this.props.canAddNewQaQcIssue ||
            prevProps.onAddNewQaQcIssue !== this.props.onAddNewQaQcIssue ||
            prevProps.match?.params?.tab !== this.props.match?.params?.tab
        ) {
            this._scheduleAddDropdownLabelTruncation();
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    isTabItemActive = item => {
        const {
            isSettingSubTab,
            isGlobalStandardsSubTab = false,
            isSurveyStandards = false,
            isSurveyUniformat = false,
            isGlobalProjectSettingsTab = false,
            isTemplateSettingsTwoTabMode = false,
            match
        } = this.props;

        const { tab = "", subTabSection = "", section = "", subTab = "", settingType = "" } = match?.params || {};

        return (
            (isSettingSubTab && subTab === item.key) ||
            (isGlobalStandardsSubTab && (tab === "basicdetails" ? "info" : tab) === item.key) ||
            ((isSurveyStandards || isSurveyUniformat) && subTabSection === item.key) ||
            (isTemplateSettingsTwoTabMode &&
                ((item.key === "basicdetails" && settingType === "basicdetails") ||
                    (item.key === "settings" && settingType && settingType !== "basicdetails"))) ||
            (isGlobalProjectSettingsTab && settingType === item.key) ||
            tab === item.key ||
            (item.key === "initiatives" && section !== "initiativeInfo")
        );
    };

    getVisibleTabs = () => {
        const { infoTabsData } = this.props;
        if (!Array.isArray(infoTabsData)) return [];

        return infoTabsData.filter(item => {
            if (!item) return false;
            if (Object.prototype.hasOwnProperty.call(item, "show")) return !!item.show;
            return true;
        });
    };

    getActiveVisibleTabIndex = () => {
        const visibleTabs = this.getVisibleTabs();
        if (!visibleTabs.length) return -1;

        return visibleTabs.findIndex(item => this.isTabItemActive(item));
    };

    getVisibleTabKeysSignature = () => {
        return this.getVisibleTabs()
            .map(item => item.key)
            .join("|");
    };

    navigateToTab = item => {
        navigateWithPrompts({
            isFormDirty: this.props.isFormDirty,
            navigateAction: () => this.handleTabClick(item)
        });
    };

    resetSliderPosition = () => {
        const slider = this.sliderRef.current;
        if (typeof slider?.slickGoTo === "function") {
            slider.slickGoTo(0, true);
        }
        this._lastAutoScrolledTabIndex = null;
    };

    autoScrollToActiveTab = (force = false) => {
        window.requestAnimationFrame(() => {
            const slider = this.sliderRef.current;
            if (!slider) return;

            const activeIndex = this.getActiveVisibleTabIndex();
            if (activeIndex < 0) return;

            if (!force && this._lastAutoScrolledTabIndex === activeIndex) return;
            this._lastAutoScrolledTabIndex = activeIndex;

            const listEl = slider?.innerSlider?.list;
            if (listEl) {
                const slides = listEl.querySelectorAll(".slick-slide");
                const activeSlide = slides?.[activeIndex];
                if (activeSlide) {
                    const edgePaddingPx = 24;
                    const listRect = listEl.getBoundingClientRect();
                    const slideRect = activeSlide.getBoundingClientRect();
                    const isOutLeft = slideRect.left < listRect.left + edgePaddingPx;
                    const isOutRight = slideRect.right > listRect.right - edgePaddingPx;

                    if (!isOutLeft && !isOutRight) return;

                    const leadTabs = 2;
                    const targetIndex = Math.max(activeIndex - leadTabs, 0);

                    if (typeof slider.slickGoTo === "function") {
                        slider.slickGoTo(targetIndex, true);
                        return;
                    }
                }
            }

            // Fallback when DOM isn't ready: still keep a small lead.
            if (typeof slider.slickGoTo === "function") {
                const leadTabs = 2;
                slider.slickGoTo(Math.max(activeIndex - leadTabs, 0), true);
            }
        });
    };

    observeTableTopMenuWidth() {
        let resizeTimeout = null;
        this.resizeObserver = new ResizeObserver(entries => {
            if (!resizeTimeout) {
                resizeTimeout = setTimeout(() => {
                    resizeTimeout = null;
                    for (let entry of entries) {
                        this.handleResize();
                        break;
                    }
                }, 100);
            }
        });
        const tableTopMenu = this.props?.isRecommendation
            ? document.querySelector(".slick-slider.slick-initialized")
            : document.querySelector(".table-top-menu.outer-flx-section");
        if (tableTopMenu) {
            this.resizeObserver.observe(tableTopMenu);
        }
    }

    handleResize = () => {
        const tableTopMenu = this.props?.isRecommendation
            ? document.querySelector(".slick-slider.slick-initialized")
            : document.querySelector(".table-top-menu.outer-flx-section");
        if (!tableTopMenu) {
            return;
        }
        const tableTopMenuWidth = tableTopMenu.offsetWidth;
        const innerSliderNode = this.sliderRef.current && this.sliderRef.current.innerSlider;
        if (!innerSliderNode) {
            return;
        }
        const trackNode = innerSliderNode.list;

        const slides = trackNode.querySelectorAll(".slick-slide");
        let totalWidth = 0;
        slides.forEach(slide => {
            const contentWrapper = slide.firstElementChild;
            totalWidth += contentWrapper.offsetWidth;
        });
        const showArrows = totalWidth > tableTopMenuWidth + 36;
        // if (!showArrows && typeof this?.sliderRef?.current?.slickGoTo === "function") {
        //     this.sliderRef.current.slickGoTo(0, true);
        // }
        this.setState({ SlickBtnShow: showArrows });
        this.setState({ showArrows });
        const slidesToShow = this.calculateTrailingVisibleCount(trackNode, slides);
        this.setState({ slidesToShow, slidesToScroll: Math.max(1, Math.round(slidesToShow * 0.75)) });
        this._scheduleAddDropdownLabelTruncation();
    };

    // Measured from the end: slick clamps scrolling at slideCount - slidesToShow, so this makes the last stop show the final tab.
    calculateTrailingVisibleCount = (trackNode, slides) => {
        const visibleWidth = trackNode.offsetWidth;
        if (!visibleWidth || !slides.length) return 1;

        let usedWidth = 0;
        let fittingSlides = 0;
        for (let i = slides.length - 1; i >= 0; i--) {
            const contentWrapper = slides[i].firstElementChild;
            usedWidth += contentWrapper ? contentWrapper.offsetWidth : slides[i].offsetWidth;
            if (usedWidth > visibleWidth) break;
            fittingSlides += 1;
        }
        return Math.max(1, fittingSlides);
    };

    handleTabsWheel = e => {
        const slider = this.sliderRef.current;
        if (!slider || !this.state.SlickBtnShow) return;

        const delta = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.shiftKey ? e.deltaY : 0;
        if (!delta) return;
        e.preventDefault();

        const now = Date.now();
        if (now - this._lastWheelAt < 120) return;
        this._lastWheelAt = now;

        const currentSlide = slider.innerSlider?.state?.currentSlide ?? 0;
        slider.slickGoTo(currentSlide + (delta > 0 ? 2 : -2));
    };

    _scheduleAddDropdownLabelTruncation = () => {
        window.requestAnimationFrame(() => this._updateAddDropdownLabelTruncation());
    };

    _updateAddDropdownLabelTruncation = () => {
        const el = this.addNewLabelRef.current;
        if (!el) {
            if (this.state.addDropdownLabelTruncated) {
                this.setState({ addDropdownLabelTruncated: false }, rebuildGlossaryTooltip);
            }
            return;
        }
        const truncated = el.scrollWidth > el.clientWidth + 1;
        if (this.state.addDropdownLabelTruncated !== truncated) {
            this.setState({ addDropdownLabelTruncated: truncated }, rebuildGlossaryTooltip);
        }
    };
    toggleFavorite = item => {
        this.setState({ quickLinksConfirmationModal: { show: true, item } });
    };

    renderQuickLinksConfirmationModal = () => {
        if (!this.state.quickLinksConfirmationModal?.show) return null;
        const { item } = this.state.quickLinksConfirmationModal;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={
                            !item?.linkId
                                ? "Are you sure you want to add this Tab to Bookmarks?"
                                : "Are you sure you want to remove this Tab from Bookmarks?"
                        }
                        message={"Bookmarks menu is accessible in Dashboard"}
                        type="cancel"
                        onNo={() => this.setState({ quickLinksConfirmationModal: { show: false, item: null } })}
                        onYes={this.handleAddToQuickLinks}
                    />
                }
                onCancel={() => this.setState({ quickLinksConfirmationModal: { show: false, item: null } })}
            />
        );
    };

    handleAddToQuickLinks = async () => {
        this.setState({ quickLinksConfirmationModal: { show: false, item: null } });
        const user_id = localStorage.getItem("userId");
        const { item } = this.state.quickLinksConfirmationModal;
        if (item.linkId) {
            await this.props.deleteQuickLinks(item.linkId, user_id);
        } else {
            const params = {
                user_id,
                name: getQuickLinkStoredName(item.name, item.relativePath),
                url: item.relativePath,
                key: item.permissionKeys ? JSON.stringify(item.permissionKeys) : null
            };
            await this.props.addToQuickLinks(params);
        }
    };

    render() {
        const similarFields = ["Trade", "System", "Sub System", "Recommendation Type", "Status", "Inspection Date"];

        const geoHierarchyFields = ["Region", "Site", "Building", "Building Type", "Addition", "Floor", "Room", "Space Type"];

        const settings = {
            infinite: false,
            variableWidth: true,
            // Under variableWidth this is the scroll clamp, not a tab width — it also drives the next-arrow disabled state.
            slidesToShow: this.state.slidesToShow,
            slidesToScroll: this.state.slidesToScroll,
            // Slick ignores input while animating, so a slow animation swallows quick repeat clicks.
            speed: 300,
            waitForAnimate: false,
            // Touch swipe only — mouse dragging would compete with clicking a tab.
            swipe: true,
            draggable: false,
            swipeToSlide: true,
            arrows: this.state.SlickBtnShow,
            prevArrow: (
                <button type="button" className="slick-prev pull-left">
                    <i className="fas fa-chevron-left"></i>
                </button>
            ),
            nextArrow: (
                <button type="button" className="slick-next pull-right">
                    <i className="fas fa-chevron-right"></i>
                </button>
            )
        };
        const {
            infoTabsData,
            basicDetails,
            isSettingSubTab,
            isTabWideClass = false,
            hasCreate,
            isQaQcReviewerUser,
            qaqcPendingStatus,
            entityName,
            CrBasedRecommendationBtn,
            isMobileRecommendation = false,
            isQuickLink = false,
            isGlobalStandardsSubTab = false,
            isSurveyStandards = false,
            isSurveyUniformat = false,
            hasLock = true,
            hasMRAssetConvertButton = false,
            isMobileRecomView = false,
            isGlobalProjectSettingsTab = false,
            isTemplateSettingsTwoTabMode = false,
            handleRestoreBtn = false,
            hasRestoreBtn = false,
            canAddNewQaQcIssue = false,
            onAddNewQaQcIssue
        } = this.props;
        const { tab = "", subTabSection = "" } = this.props?.match?.params;
        const currentUser = localStorage.getItem("userId");
        const isSameOwner = currentUser === basicDetails?.surveyor_id;
        const links = this.props.getQuickLinksResponse;
        const addNewDropdownLabel =
            canAddNewQaQcIssue && hasCreate
                ? `Add New ${entityName} / QA-QC Issue`
                : canAddNewQaQcIssue
                  ? "Add New QA/QC Issue"
                  : `Add New ${entityName}`;

        return (
            <React.Fragment>
                <ReactTooltip id="favoriteQuickLink" place="bottom" effect="solid" backgroundColor="#007bff" />
                <ReactTooltip id="info-tabs-add-dropdown-full" place="bottom" effect="solid" backgroundColor="#007bff" />
                <div
                    className={`table-top-menu outer-flx-section ${isMobileRecomView ? "mobile-recom-view-tab" : ""} ${
                        hasCreate || CrBasedRecommendationBtn ? "qaqc-section" : ""
                    } ${this.props?.CrBasedRecommendationBtn ? "cap-req" : ""}`}
                >
                    <ul
                        className={
                            this.props.isTabClass
                                ? `tab-data ${isTabWideClass ? "top-head-wide" : ""}`
                                : this.props?.isNoramlRecom
                                  ? `recom-tab`
                                  : null
                        }
                        onWheel={this.handleTabsWheel}
                    >
                        <Slider {...settings} ref={this.sliderRef}>
                            {infoTabsData && infoTabsData.length
                                ? infoTabsData.map((item, i) => {
                                      let show = true;
                                      if (item.hasOwnProperty("show")) {
                                          show = item.show;
                                      }
                                      let paths = this.props.match.path.split("/");
                                      item.relativePath = `${paths[1]}/${this.props.match.params.section}/{id}/${item.key}`;
                                      item.linkId = links?.data?.find(link => link.url === item.relativePath)?.id;
                                      return (
                                          show && (
                                              <div>
                                                  <li
                                                      className={`cursor-pointer${
                                                          (isSettingSubTab && this.props.match.params.subTab === item.key) ||
                                                          (isGlobalStandardsSubTab && (tab === "basicdetails" ? "info" : tab) === item.key) ||
                                                          ((isSurveyStandards || isSurveyUniformat) && subTabSection === item.key) ||
                                                          (isTemplateSettingsTwoTabMode &&
                                                              ((item.key === "basicdetails" && this.props.match.params?.settingType === "basicdetails") ||
                                                                  (item.key === "settings" &&
                                                                      this.props.match.params?.settingType &&
                                                                      this.props.match.params?.settingType !== "basicdetails"))) ||
                                                          (isGlobalProjectSettingsTab && this.props.match.params?.settingType === item.key)
                                                              ? " active"
                                                              : this.props.match.params.tab === item.key ||
                                                                  (item.key === "initiatives" && this.props.match.params.section !== "initiativeInfo")
                                                                ? " active"
                                                                : ""
                                                      } ${item.showIndicator && !!qaqcPendingStatus ? "d-flex" : ""} ${
                                                          isQuickLink ? "favourite-recom-tb" : ""
                                                      }`}
                                                      key={i}
                                                      onClick={() => this.navigateToTab(item)}
                                                  >
                                                      {item.showIndicator && !!qaqcPendingStatus && (
                                                          <span className="dots">
                                                              <img src={`/img/${qaqcPendingStatus}.svg`} className="status-icons dots" alt="" />
                                                          </span>
                                                      )}
                                                      {isQuickLink ? (
                                                          <div className="d-flex">
                                                              <WithTooltip>{item.name}</WithTooltip>
                                                              <i
                                                                  className="favourite-recom-icon"
                                                                  data-tip={
                                                                      item.linkId
                                                                          ? "Remove this Tab From Dashboard Bookmarks"
                                                                          : "Add this Tab to Dashboard Bookmarks"
                                                                  }
                                                                  data-for="favoriteQuickLink"
                                                                  onClick={e => {
                                                                      e.stopPropagation();
                                                                      this.toggleFavorite(item);
                                                                  }}
                                                              >
                                                                  <img src={item.linkId ? StarActiveIcon : StarIcon} alt="" />
                                                              </i>
                                                          </div>
                                                      ) : (
                                                          <WithTooltip>{item.name}</WithTooltip>
                                                      )}
                                                  </li>
                                              </div>
                                          )
                                      );
                                  })
                                : null}
                            {!hasCreate && isQaQcReviewerUser && !basicDetails?.locked && onAddNewQaQcIssue ? (
                                <button className="issue-new-btn" onClick={() => onAddNewQaQcIssue()}>
                                    Add New QA/QC Issue
                                </button>
                            ) : null}
                        </Slider>
                    </ul>
                    <div
                        className={`rgt m-0 p-0 ${isMobileRecommendation ? "convert-rcm-btn" : ""} ${hasMRAssetConvertButton ? "btn-convert-pr" : ""} ${
                            hasCreate ? "info-tabs-rgt-has-add" : ""
                        }`}
                    >
                        {hasCreate && (
                            <div
                                className={`info-tabs-add-wrap ${this.props?.CrBasedRecommendationBtn ? "" : "create-new-btn"} recom-lock-btn ${
                                    this.props.match.params.tab === "qaqc" ? "mt-0" : ""
                                } ${this.props?.CrBasedRecommendationBtn ? "mr-2" : ""}`}
                            >
                                <Dropdown className="info-tabs-add-dropdown">
                                    <Dropdown.Toggle
                                        id="dropdown-basic"
                                        className="add-btn info-tabs-add-dropdown__toggle"
                                        {...(this.state.addDropdownLabelTruncated
                                            ? {
                                                  "data-for": "info-tabs-add-dropdown-full",
                                                  "data-tip": addNewDropdownLabel
                                              }
                                            : {})}
                                    >
                                        <span className="edit-icn-bx info-tabs-add-toggle-inner">
                                            <i className="fas fa-plus pad-bot"></i>
                                            <span className="info-tabs-add-dropdown__label" ref={this.addNewLabelRef}>
                                                {addNewDropdownLabel}
                                            </span>
                                        </span>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu className="info-tabs-add-menu">
                                        {hasCreate && (
                                            <>
                                                <Dropdown.Item
                                                    data-tip={`This option will generate a new ${entityName}, a blank form, no data copied over.`}
                                                    data-for="regular"
                                                    onClick={() => this.props.createNewData(basicDetails, RECOMMENDATION_SOURCE_TYPES.REGULAR)}
                                                >
                                                    <ReactTooltip id="regular" place="left" effect="solid" backgroundColor="#007bff" />
                                                    Add New {entityName}
                                                </Dropdown.Item>
                                                <Dropdown.Item
                                                    data-for="similar"
                                                    data-tip={`This option will generate a new ${entityName}, Similar to the current one, while copying over the following fields:<div class="head-tag mt-2">Geo Hierarchy:</div>${geoHierarchyFields
                                                        .map(field => `<div class="sub-head-tag" key="${field}">${field}</div>`)
                                                        .join("")}<div class="head-tag mt-2">Recommendation:</div>${similarFields
                                                        .map(field => `<div class="sub-head-tag" key="${field}">${field}</div>`)
                                                        .join("")}`}
                                                    onClick={() => this.props.createNewData(basicDetails, RECOMMENDATION_SOURCE_TYPES.SIMILAR)}
                                                >
                                                    <ReactTooltip
                                                        id="similar"
                                                        place="bottom"
                                                        effect="solid"
                                                        backgroundColor="#007bff"
                                                        html={true}
                                                        className="tooltip-re-cm div"
                                                        getContent={dataTip => (dataTip ? sanitizeHtml(dataTip) : "")}
                                                    />
                                                    Add Similar {entityName}
                                                </Dropdown.Item>
                                                <Dropdown.Item
                                                    data-tip={
                                                        isSameOwner
                                                            ? `This option will generate a new ${entityName}, a Duplicate of the current one, while copying over ALL fields except the Capital Spending Plan (CSP) costs, quantity, opinions of cost, total opinions of cost, installed year, inspection date, useful life remaining, end of service life, and any dynamic field value linked to BBI or BSI.`
                                                            : `This option will generate a new ${entityName}, a Duplicate of the current one, while copying over ALL fields except the Capital Spending Plan (CSP) costs, quantity, opinions of cost, total opinions of cost, installed year, inspection date, useful life remaining, end of service life, surveyor field, and any dynamic field value linked to BBI or BSI.`
                                                    }
                                                    data-for="duplicate_no_csp"
                                                    onClick={() => this.props.createNewData(basicDetails, RECOMMENDATION_SOURCE_TYPES.DUPLICATE_NO_CSP)}
                                                >
                                                    <ReactTooltip id="duplicate_no_csp" place="left" effect="solid" backgroundColor="#007bff" />
                                                    Add Duplicate - <b>No CSP</b> {entityName}
                                                </Dropdown.Item>
                                                {checkPermission("forms", permissions.RECOMMENDATION_FULL_DUPLICATE, "create") && (
                                                    <Dropdown.Item
                                                        data-tip={`This option will generate a new ${entityName}, a complete copy of the current one. ALL fields are copied over, including the Capital Spending Plan (CSP) costs, the inspection date and the surveyor.<div class="head-tag mt-2">Everything attached is copied too:</div>${[
                                                            "Images",
                                                            "Documents",
                                                            "QA/QC issues",
                                                            "Project costs",
                                                            "Mobile Recommendations",
                                                            "Capital Requests"
                                                        ]
                                                            .map(field => `<div class="sub-head-tag" key="${field}">${field}</div>`)
                                                            .join("")}<div class="head-tag mt-2">The linked asset stays the same</div><div class="sub-head-tag">Both ${entityName}s point to the same asset. No new asset is created.</div>`}
                                                        data-for="duplicate_full"
                                                        onClick={() => this.props.createNewData(basicDetails, RECOMMENDATION_SOURCE_TYPES.FULL_DUPLICATE)}
                                                    >
                                                        <ReactTooltip
                                                            id="duplicate_full"
                                                            place="left"
                                                            effect="solid"
                                                            backgroundColor="#007bff"
                                                            html={true}
                                                            className="tooltip-re-cm div"
                                                            getContent={dataTip => (dataTip ? sanitizeHtml(dataTip) : "")}
                                                        />
                                                        Add Duplicate - <b>Full</b> {entityName}
                                                    </Dropdown.Item>
                                                )}
                                                <Dropdown.Item
                                                    data-tip={`This option will generate a new ${entityName} while copying over the Geo Hierarchy fields:${geoHierarchyFields
                                                        .map(field => `<div class="sub-head-tag" key="${field}">${field}</div>`)
                                                        .join("")}`}
                                                    data-for="geohierarchy"
                                                    onClick={() => this.props.createNewData(basicDetails, RECOMMENDATION_SOURCE_TYPES.GEO_HIERARCHY)}
                                                >
                                                    <ReactTooltip
                                                        id="geohierarchy"
                                                        place="bottom"
                                                        effect="solid"
                                                        backgroundColor="#007bff"
                                                        html="true"
                                                        className="tooltip-re-cm"
                                                        getContent={dataTip => (dataTip ? sanitizeHtml(dataTip) : "")}
                                                    />
                                                    Add Same Geo Hierarchy {entityName}
                                                </Dropdown.Item>
                                            </>
                                        )}
                                        {canAddNewQaQcIssue && onAddNewQaQcIssue ? (
                                            <>
                                                {hasCreate && <Dropdown.Divider className="info-tabs-add-menu__qa-split" />}
                                                <Dropdown.Item
                                                    className="info-tabs-add-menu__qa-item"
                                                    data-tip="Create a new QA/QC issue on this recommendation."
                                                    data-for="qaqc-add-issue"
                                                    data-place="left"
                                                    onClick={() => onAddNewQaQcIssue()}
                                                >
                                                    <ReactTooltip
                                                        id="qaqc-add-issue"
                                                        place="left"
                                                        effect="solid"
                                                        backgroundColor="#007bff"
                                                    />
                                                    Add New QA/QC Issue
                                                </Dropdown.Item>
                                            </>
                                        ) : null}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        )}
                        <div className="d-flex">
                            {hasRestoreBtn && (
                                <>
                                    <ReactTooltip
                                        id="restore"
                                        place="bottom"
                                        effect="solid"
                                        backgroundColor="#007bff"
                                        html="true"
                                        className="tooltip-re-cm"
                                        getContent={dataTip => (dataTip ? sanitizeHtml(dataTip) : "")}
                                    />
                                    <div className={`recom-lock-btn mr-0 ${hasMRAssetConvertButton ? "create-new-btn" : ""}`}>
                                        <button
                                            className="qaqc-passed-btn resotre-button"
                                            onClick={handleRestoreBtn}
                                            data-for={"restore"}
                                            data-tip={"Restore to Synced Recommendation Values"}
                                        >
                                            <i class="fas fa-history"></i> Restore
                                        </button>
                                    </div>
                                </>
                            )}

                            {this.props?.CrBasedRecommendationBtn &&
                                !hasMRAssetConvertButton &&
                                (localStorage.getItem("role") === "super_admin" ||
                                    localStorage.getItem("crApprover") === "true" ||
                                    this.props.hasMRConvertButton) && (
                                    <>
                                        <ReactTooltip
                                            id="convert"
                                            place="bottom"
                                            effect="solid"
                                            backgroundColor="#007bff"
                                            html="true"
                                            className="tooltip-re-cm"
                                            getContent={dataTip => (dataTip ? sanitizeHtml(dataTip) : "")}
                                        />
                                        <button
                                            className={`add-btn ${this.props?.disableConvert ? "cursor-diabled" : ""}  ${
                                                isMobileRecommendation ? "mr-0" : "mr-2"
                                            }`}
                                            disabled={this.props?.disableConvert}
                                            onClick={() => this.props?.createRecommendationFromCr(this.props?.recommendationDetails)}
                                            data-for={"convert"}
                                            data-tip={
                                                this.props?.disableConvert
                                                    ? "New fields exist, please handle them to add new mobile recommendations."
                                                    : ""
                                            }
                                        >
                                            <i class="fas fa-calendar-plus"></i>
                                            {this.props.hasMRConvertButton ? "Convert to Production" : "Convert to Recommendation"}
                                        </button>
                                    </>
                                )}

                        {hasMRAssetConvertButton ? (
                            <div
                                className={`create-new-btn recom-lock-btn mr-1 mr-convert-btn `}
                                data-for={"converts"}
                                data-tip={this.props?.disableConvert ? "New fields exist, please handle them to add new mobile recommendations." : ""}
                            >
                                <ReactTooltip
                                    id="converts"
                                    place="bottom"
                                    effect="solid"
                                    backgroundColor="#007bff"
                                    html="true"
                                    className="tooltip-re-cm"
                                    getContent={dataTip => (dataTip ? sanitizeHtml(dataTip) : "")}
                                />
                                <Dropdown>
                                    <Dropdown.Toggle
                                        id="dropdown-basic"
                                        className={`add-btn ${this.props?.disableConvert ? "cursor-diabled" : ""}`}
                                        disabled={this.props?.disableConvert}
                                    >
                                        <span className="edit-icn-bx">
                                            <i className="fas fa-plus pad-bot"></i> Convert to Production
                                        </span>
                                    </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                            {checkPermission("forms", permissions.RECOMMENDATIONS, "create") && (
                                                <Dropdown.Item
                                                    onClick={() => this.props?.createRecommendationFromCr(this.props?.recommendationDetails, "both")}
                                                >
                                                    <ReactTooltip id="regular" place="left" effect="solid" backgroundColor="#007bff" />
                                                    Convert to Recommendation with Asset
                                                </Dropdown.Item>
                                            )}
                                            {checkPermission("forms", permissions.ASSETS, "create") && (
                                                <Dropdown.Item
                                                    onClick={() => this.props?.createRecommendationFromCr(this.props?.recommendationDetails, "asset")}
                                                >
                                                    <ReactTooltip
                                                        id="similar"
                                                        place="bottom"
                                                        effect="solid"
                                                        backgroundColor="#007bff"
                                                        className="tooltip-re-cm div"
                                                    />
                                                    Convert to Asset
                                                </Dropdown.Item>
                                            )}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
                {basicDetails && basicDetails && hasLock ? (
                    <div className="lock-main">
                        {this.props.isRecommendation && basicDetails?.is_survey_lock
                            ? this.recommendationSurveyLockDropdown(basicDetails)
                            : basicDetails && basicDetails.locked === true
                              ? this.lockIcon(basicDetails.locked)
                              : this.unlockIcon(basicDetails.locked)}
                    </div>
                ) : (
                    ""
                )}
                {this.renderQuickLinksConfirmationModal()}
            </React.Fragment>
        );
    }
}

const mapDispatchToProps = {
    addToQuickLinks,
    getQuickLinks,
    deleteQuickLinks
};
const mapStateToProps = state => {
    const {
        recommendationsReducer,
        commonReducer: { isFormDirty },
        dashboardReducer: { getQuickLinksResponse },
        projectReducer
    } = state;
    return { recommendationsReducer, isFormDirty, getQuickLinksResponse, projectReducer };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InfoTabs));
